import PropTypes from 'prop-types';
import React from 'react';
import Loader from '../../../components/simpleSpinner';

const SummaryBody = ({columns, loading, buttons, POS, truBlue}) => {

  let buttonsWrapper;

  if(buttons) {
    buttonsWrapper = buttons.map(function(data, i) {
      return  (!data.posOnly || data.posOnly && POS) && (!data.truBlueOnly || data.truBlueOnly && truBlue) ?
        <div key={i} className='col-sm-2'>
          <button onClick={() => window.location = data.link} className='report-button'>
            {data.label}
          </button>
        </div> : ''
      ;
    });
  }

  return (
    <div className='report-body'>
      {!loading ?
        <div>
          <div className='row'>
            {columns.map((b, i) => {
              return (
                <div key={i} className={'col-sm-' + (b.width || 2) + (b.hidden ? ' hide' : '')}>
                  <div className='form-group'>
                    <label>{b.label}</label>
                    <div className='editable-textfield'>
                      <div className='form-control-static'>
                        <span>{b.value}</span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <div className='row buttons-container'>
            {buttonsWrapper}
          </div>
        </div>        :
        <Loader/>
    }
    </div>
  );
};

SummaryBody.propTypes = {
  columns: PropTypes.array,
  buttons: PropTypes.array,
  loading: PropTypes.bool,
  POS: PropTypes.bool,
  truBlue: PropTypes.bool,
};

export default SummaryBody;
